/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const CopyItemIconOutline = createIcon({
  displayName: 'CopyItemIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect
        x="3"
        y="7"
        width="14"
        height="14"
        rx="3"
        strokeWidth="1.5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8,3.87866A2.99049,2.99049,0,0,1,10.12134,3H18a3,3,0,0,1,3,3v7.87866A2.99049,2.99049,0,0,1,20.12134,16"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const CopyItem: FC<CustomIconProps> = (props) => {
  switch (props.variant || 'outline') {
    default:
      return <CustomIcon as={CopyItemIconOutline} {...props} />
  }
}

export default memo(CopyItem)
